import React from "react";

const GuidelineYoungAchiever = () => {
  return (
    <div className="guideline-container">
      <h2 className="guideline-heading">Young Achiever of the Year</h2>
     <br></br>
      <p><strong>Objective:</strong>Young achiever of the Year in the Oil and Gas Industry recognizes exceptional contribution in the line of work that sets one apart from her peers.</p>
      <br></br>
      <p><strong>Eligibility criteria:</strong></p>
      <ul>
        <li>Candidate not over 40 years of age as on the date of filling the application form .</li>
        <li>Only 3 nominations from an organization duly endorsed by Director (HR) in case of PSUs and CEOs of Private Companies would be considered.</li>
        <li>Endorsement letter from Dir (HR) or CEO to be submitted along with the application; failing which, application will not be considered.</li>
      </ul>
      <br/>
      <p><strong>Evaluation Guideline:</strong>Evaluation will be done on basis of the responses mentioned by the Applicant in the input sheet.</p>
    </div>
  );
};

export default GuidelineYoungAchiever;